var style = {
  "Container": "_Container_3h6ct_1"
};

export { style as default };
